type TimeoutId = ReturnType<typeof setTimeout>;
type Callback = () => void;

/*                                                                                                   */
/*                                                                              */
const MAX_CLEANUP_PERIOD_IN_MILLIS = 20 * 24 * 60 * 60 * 1000;

export interface ExpiryScheduler {
  scheduler: (expiration: string, callback: Callback) => void
  cleanup: () => void
}

export function createExpiryScheduler(): ExpiryScheduler {
  let timeoutId: TimeoutId | null = null;
  let expirationDate: Date | null = null;
  let scheduledCallback: Callback | null = null;

  /**
 *
 */
  const createExpiryTimeout = () => {
    if (!expirationDate || !scheduledCallback) return;

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    const delayMs: number = Math.min(Math.max(expirationDate.getTime() - new Date().getTime(), 1), MAX_CLEANUP_PERIOD_IN_MILLIS);
    timeoutId = setTimeout(() => {
      scheduledCallback!();
      cleanup()
    }, delayMs);
  }

  /**
 *
 */
  const handleVisibilityChange = () => {
    if (document.hidden) {
      clearTimeout(timeoutId!);
      return;
    }
    createExpiryTimeout()
  }

  /**
 *
 */
  const cleanup = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    document.removeEventListener('visibilitychange', handleVisibilityChange)
    scheduledCallback = null;
    expirationDate = null;
  }

  /**
 *
 *
 *
 *
 */
  const scheduler = (expiration: string, callback: Callback) => {
    cleanup()

    scheduledCallback = callback;
    expirationDate = new Date(expiration);

    document.addEventListener('visibilitychange', handleVisibilityChange);
    createExpiryTimeout();
  }

  return {
    scheduler,
    cleanup
  };
}
